import { render } from "./DateForm.vue?vue&type=template&id=1b8c2b82"
import script from "./DateForm.vue?vue&type=script&lang=js"
export * from "./DateForm.vue?vue&type=script&lang=js"

import "./DateForm.vue?vue&type=style&index=0&id=1b8c2b82&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__